import { render, staticRenderFns } from "./LexileStandard.vue?vue&type=template&id=25de6266&"
import script from "./LexileStandard.vue?vue&type=script&lang=js&"
export * from "./LexileStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports